import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop";

import Home from "./views/Home";
import Shipping from "./views/Step10_Shipping";
import Checkout from "./views/Step20_Checkout";
import Confirmation from "./views/Step30_Confirmation";

import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/:language/home" element={<PageNotFound />} />
                <Route path="/:language/home/:eventId" element={<Home />} />
                <Route path="/:language/shipping" element={<Shipping />} />
                <Route path="/:language/checkout" element={<Checkout />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
                <Route path="/:language/confirmation" element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
